import { render, staticRenderFns } from "./OrderPaymentCertificate.vue?vue&type=template&id=fea78ea8&scoped=true&"
import script from "./OrderPaymentCertificate.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentCertificate.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentCertificate.vue?vue&type=style&index=0&id=fea78ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea78ea8",
  null
  
)

export default component.exports